import { DATE_FORMAT_API } from 'constants/app'
import { queryAPI, serialize } from 'utils'
import { SESS_TOKEN } from 'constants/admin'
import moment from 'moment'

export const Service = {
    list: {
        analysis: listAnalysis,
        levels: listTideLevels,
        highestTides: listHighestTides,
        docks: listDocks,
        emailAttachments: listEmailAttachments,
    },
    get: {
        analysis: getAnalysis,
        status: getStatus,
        dock: getDock,
    },
    create: {
        analysis: createAnalysis,
        dock: createDock,
        emailAttachment: createEmailAttachment,
    },
    update: {
        analysis: updateAnalysis,
        dock: updateDock,
        emailAttachment: updateEmailAttachment,
        emailAttachmentReorder: updateEmailAttachmentReorder,
    },
    delete: {
        emailAttachment: deleteEmailAttachment,
    },
    send: {
        mail: sendMail,
    },
}

function getAuthToken() {
    return localStorage.getItem(SESS_TOKEN)
}

const GET_PARAMS = {
    method: 'GET',
}

// privée
async function listAnalysis() {
    const token = getAuthToken()
    const params = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }
    return await queryAPI(`analyzes`, params)
}

// public
async function listTideLevels(baseDate, dateOffset) {
    if (!baseDate) baseDate = moment().utc()
    if (!Array.isArray(dateOffset) || dateOffset.length !== 2) dateOffset = [-12, 24]

    const filters = {
        date: [
            moment(baseDate).utc().add(dateOffset[0], 'hour').format(DATE_FORMAT_API),
            moment(baseDate).utc().add(dateOffset[1], 'hour').format(DATE_FORMAT_API),
        ],
        for_captain: 0,
    }

    return await queryAPI(`api_datas/?${serialize(filters)}`, GET_PARAMS)
}

// public
async function listDocks() {
    return await queryAPI(`docks`, GET_PARAMS)
}

// public
async function getStatus() {
    return await queryAPI(`status`, GET_PARAMS)
}

// protected
async function getAnalysis(alias) {
    return await queryAPI(`analyzes/${alias}`, GET_PARAMS)
}

// public
async function getDock(dockId) {
    return await queryAPI(`docks/${dockId}`, GET_PARAMS)
}

// privée
async function createAnalysis(analysis) {
    const tides = await listHighestTides()
    const token = getAuthToken()
    const params = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            analyze: {
                ...analysis,
                highest_tides: JSON.stringify(tides.highest_tides),
            },
        }),
    }

    return await queryAPI(`analyzes`, params)
}

// privée
async function updateAnalysis(analysis) {
    const token = getAuthToken()
    console.log('update analyses', token)
    const params = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            analyze: analysis,
        }),
    }

    return await queryAPI(`analyzes/${analysis.alias}`, params)
}

// privée
async function createDock(dock) {
    const token = getAuthToken()
    const params = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            dock: dock,
        }),
    }

    return await queryAPI(`docks`, params)
}

// privée
async function updateDock(dock) {
    const token = getAuthToken()
    const params = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            dock: dock,
        }),
    }

    return await queryAPI(`docks/${dock.id}`, params)
}

// public
async function listHighestTides() {
    return await queryAPI(`analyzes/new`, GET_PARAMS)
}

// privée
async function sendMail(dest, id) {
    const token = getAuthToken()
    const params = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    }

    return await queryAPI(`analyzes/${id}/mail?receiver=${dest}`, params)
}

// public
async function listEmailAttachments() {
    return await queryAPI(`email_attachments`, GET_PARAMS)
}

// privée
async function createEmailAttachment(data) {
    const token = getAuthToken()
    const params = {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    }
    return await queryAPI(`email_attachments`, params)
}

// privée
async function updateEmailAttachment(id, data) {
    const token = getAuthToken()
    const params = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    }
    return await queryAPI(`email_attachments/${id}`, params)
}

// privée
async function deleteEmailAttachment(id) {
    const token = getAuthToken()
    const params = {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    }
    return await queryAPI(`email_attachments/${id}`, params)
}

// privée
async function updateEmailAttachmentReorder(positions) {
    const token = getAuthToken()
    const params = {
        method: 'PUT',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ positions }),
    }
    return await queryAPI(`email_attachments/reorder`, params)
}
